<template>
  <div class="accountHome">
    <div :class="[{ 'is-hide': isActiveBg}, 'cover-box']">
      <div :class="[{ 'is-cover-box-hide2': isActive == 1 && !isShowTaxIcon }, { 'is-cover-box-hide3': isActive == 1 && isShowTaxIcon }, 'dialog-cover-box', 'img-bg']">
        <div v-show="isTimerJump" class="look-again-btn" @click="closeFun(true)">跳过 {{timerJump}}</div>
        <div class="logo-box">
          <img src="../../assets/images/yearData/2021/yearIndex-title.png" alt="">
        </div>
        <img :class="[{ 'is-cover-box-hide2': isActive == 1 && !isShowTaxIcon }, { 'is-cover-box-hide3': isActive == 1 && isShowTaxIcon }, 'cover-btn']" src="../../assets/images/yearData/2021/year-bill-index-btn.png" alt="" @click="openYearInfo">
      </div>
    </div>
    <van-row class="head">
      <van-dropdown-menu>
        <van-dropdown-item
          v-model="company_value"
          :options="company_option"
          @change="handleCompanyChange"
          @opened="openedDropdownMenu"
        />
      </van-dropdown-menu>
      <div v-if="!isTestAccount" class="scan-btn-wrap" @click="scanQrcode">
        <div class="scan-btn"></div>
      </div>
      <div class="swipeContent">
        <div class="newCl" @click="linkSkip('customerList',{reffilter:'all'},'','','我的客户');">
          <span class="number">{{cuTotal}}</span>
        </div>
        <div class="newCl_desc" @click="linkSkip('customerList',{reffilter:'all'},'','','我的客户数')">
          <span class="myCustomer">我的客户数</span>
        </div>
      </div>
    </van-row>
    <van-row class="mainContainer">
      <van-col
        :span="colSpan"
        class="mainContainerCol"
        @click.native="linkSkip('customerFollowList',{},'','','客户跟进')"
      >
        <img class="fImg" src="../../assets/images/bannerIcon/follow.png" alt="">
        <div class="title">客户跟进</div>
        <!-- <span class="bline"></span> -->
      </van-col>
      <van-col
        :span="colSpan"
        class="mainContainerCol"
        @click.native="linkSkip('customerBillList',{},'','','企业收票')"
      >
        <img class="bImg" src="../../assets/images/bannerIcon/bill.png" alt="">
        <div class="title">企业收票</div>
        <!-- <span class="bline"></span> -->
      </van-col>
      <van-col
        :span="colSpan"
        class="mainContainerCol"
        @click.native="linkSkip('fieldAssignment_list',{},1,'','外勤任务')"
      >
        <img class="mImg" src="../../assets/images/bannerIcon/mission.png" alt="">
        <div class="title">外勤任务</div>
        <span v-show="missionBandge" class="bandge"></span>
      </van-col>
      <van-col
        :span="colSpan"
        class="mainContainerCol"
        @click.native="linkSkip('businessServiceList',{},2,'','工商服务')"
      >
        <img class="mImg" src="../../assets/images/bannerIcon/bussRegiste.png" alt="">
        <div class="title">工商服务</div>
        <span v-show="bussBandge" class="bandge"></span>
      </van-col>
      <van-col
        :span="colSpan"
        class="mainContainerCol"
        @click.native="linkSkip('collectionHome',{},'','','新购合同')"
      >
        <img class="mImg" src="../../assets/images/bannerIcon/newContract.png" alt="">
        <div class="title">新购合同</div>
        <!-- <span class="bline"></span> -->
      </van-col>
      <van-col
        :span="colSpan"
        class="mainContainerCol"
        @click.native="linkSkip('wxRenew_list',{},'','70000001','服务收款')"
      >
        <img class="mImg" src="../../assets/images/bannerIcon/servicePayment.png" alt="">
        <div class="title">服务收款</div>
      </van-col>
      <van-col
        :span="colSpan"
        class="mainContainerCol"
        @click.native="linkSkip('dataTransfer',{},'','','资料交接')"
      >
        <img class="mImg" src="../../assets/images/bannerIcon/dataTransfer.png" alt="">
        <div class="title">资料交接</div>
      </van-col>
      <van-col
        v-if="crmBeta"
        :span="colSpan"
        class="mainContainerCol"
        @click.native="linkSkip('businessManage',{},'','','商机管理')"
      >
        <img class="mImg" src="../../assets/images/bannerIcon/business-manage-icon.png" alt="">
        <div class="title">商机管理</div>
      </van-col>
    </van-row>
    <van-row class="confirmed">
      <van-col span="24" class="confirmedCol">
        <div class="title">
          <span>收款预警</span>
        </div>
        <div v-if="isServiceEmpty" class="empty">
          <img src="../../assets/images/snodata.png" alt="暂无服务动态">
          <span class="desc">暂无客户</span>
        </div>
        <div v-else>
          <van-row
            v-show="!isaServiceEmpty"
            class="confirmedRow"
            @click.native="linkSkip('customerList',{reffilter:'expire'},'','','已到期客户')"
          >
            <van-col span="2" class="confirmedRowCol lh37">
              <i class="iconfont icon-deadline_customer fs22"></i>
            </van-col>
            <van-col span="14" class="confirmedRowCol">
              <div class="stitle">已到期客户</div>
            </van-col>
            <van-col span="8" class="confirmedRowCol">
              <div class="rightText">
                {{expexpiredCount}}
                <van-icon name="arrow"/>
              </div>
            </van-col>
          </van-row>
          <van-row
            v-show="!isbServiceEmpty"
            :class="!isaServiceEmpty ? 'confirmedRow confirmedInvest' : 'confirmedRow confirmedInvest margintop' "
            @click.native="linkSkip('customerList',{reffilter:'arrearage'},'','','欠费客户')"
          >
            <van-col span="2" class="confirmedRowCol lh37">
              <i class="iconfont icon-renew fs22 primary"></i>
            </van-col>
            <van-col span="11" class="confirmedRowCol">
              <div class="stitle">欠费客户</div>
            </van-col>
            <van-col span="11" class="confirmedRowCol">
              <div class="rightText">
                <span class="textOverflow">{{feeNot}}</span>
                <van-icon name="arrow"/>
              </div>
            </van-col>
          </van-row>
        </div>
      </van-col>
    </van-row>
    <van-row class="confirmed typeConfirm">
      <van-col span="24" class="confirmedCol">
        <div class="title">
          <span>客户类型</span>
        </div>
        <div v-if="isServiceEmpty" class="empty">
          <img src="../../assets/images/snodata.png" alt="暂无服务动态">
          <span class="desc">暂无客户</span>
        </div>
        <div v-else>
          <van-row
            v-show="!isaServiceEmpty"
            class="confirmedRow"
            @click.native="linkSkip('customerList',{reffilter:'agency'},'','','代账客户')"
          >
            <van-col span="2" class="confirmedRowCol lh37">
              <i class="iconfont icon-account_customer fs22" style="font-size:0.2rem !important;"></i>
            </van-col>
            <van-col span="14" class="confirmedRowCol">
              <div class="stitle">代账客户</div>
            </van-col>
            <van-col span="8" class="confirmedRowCol">
              <div class="rightText">
                {{asRightText}}
                <van-icon name="arrow"/>
              </div>
            </van-col>
          </van-row>
          <van-row
            v-show="!isbServiceEmpty"
            :class="!isaServiceEmpty ? 'confirmedRow confirmedInvest' : 'confirmedRow confirmedInvest margintop' "
            @click.native="linkSkip('customerList',{reffilter:'industry'},'','','工商客户')"
          >
            <van-col span="2" class="confirmedRowCol lh37">
              <i class="iconfont icon-business_customer fs22 primary"></i>
            </van-col>
            <van-col span="11" class="confirmedRowCol">
              <div class="stitle">工商客户</div>
            </van-col>
            <van-col span="11" class="confirmedRowCol">
              <div class="rightText">
                <span class="textOverflow">{{bsRightText}}</span>
                <van-icon name="arrow"/>
              </div>
            </van-col>
          </van-row>
        </div>
      </van-col>
    </van-row>
    <van-tabbar v-model="active" active-color="#1FADF6">
      <van-tabbar-item class="tac" to="/accountHome">
        <span class="block security_blue"><img src="../../assets/images/home_blue.gif" alt=""></span>
<!--        <i class="iconfont block mb5" :class="active == 0 ? 'icon-home_light' : 'icon-home'"></i>-->
        <span class="block">首页</span>
      </van-tabbar-item>
      <van-tabbar-item class="tac" to="/taxauth" v-show="isShowTaxIcon">
        <span class="block security_blue"><img src="../../assets/images/icon-security.png" alt=""></span>
<!--        <i class="iconfont iconfont-myfont iconshuiwu block mb5"></i>-->
        <span class="block">报税授权</span>
      </van-tabbar-item>
      <van-tabbar-item class="tac" to="/accountMine">
        <span class="block security_blue"><img src="../../assets/images/icon-mine.png" alt=""></span>
<!--        <i class="iconfont block mb5" :class="active == 2 ? 'icon-mine_light' : 'icon-mine'"></i>-->
        <span class="block">我的</span>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from "vue";
import wx from "weixin-js-sdk";
import { setCookie, getCookie, delCookie } from '@/common/lib/utils/cookie.js';
import moment from "moment";

import {
  Tabbar,
  TabbarItem,
  Row,
  Col,
  Icon,
  DropdownMenu,
  DropdownItem,
  Toast,
  ActionSheet
} from "vant";

Vue.use(Tabbar)
  .use(TabbarItem)
  .use(Row)
  .use(Col)
  .use(Icon)
  .use(Toast)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(ActionSheet);
export default {
  name: "accountHome",
  components: {},
  data() {
    return {
      active: 0,
      customer: {},
      asRightText: "",
      bsRightText: "",
      asBandge: false,
      bsBandge: false,
      isbServiceEmpty: false,
      isaServiceEmpty: false,
      isServiceEmpty: false,
      missionBandge: false,
      bussBandge: false,
      company_value: 0,
      company_option: [],
      cuTotal: "",
      expexpiredCount: "",
      feeNot: "",
      powerData: this.$store.state.powerData || [],
      isTestAccount: false,
      env:"",
      isShowTaxIcon: false,
      isActiveBg: window.localStorage.getItem('yearInfoOpen2021')? window.localStorage.getItem('yearInfoOpen2021') : false,
      isActive: 0,
      colSpan: 6, // 用于菜单beta控制
      roleValue:'',
      crmBeta:false,
      beforeAccCompanyId: '', // 切换前的公司id
      isCrmEndDate: false,
      isTimerJump: true,
      timerJump: 5 // 年度账单跳过倒计时
      // currentEid:''
    };
  },
  created() {
    var timestamp = Number((new Date()).getTime()); // 当前毫秒
    let timeStr = 1644768000000; // 2022-02-14 00:00:00
    if (timestamp > timeStr) {
      this.isActiveBg = true
    }
    let from = this.$route.params.from
    if (from != 'login') {
      this.isActiveBg = true
    }
  },
  beforeMount() {
    Vue.prototype.$cookieStore = {
      setCookie,
      getCookie,
      delCookie
    }
  },
  mounted() {
    this.getRnv()
    //报税按钮在有报税权限和小程序中显示
    if (window.sessionStorage.getItem('taxAuth') && window.sessionStorage.getItem('taxAuth') !== '{}' && JSON.parse(window.sessionStorage.getItem('taxAuth')).phone) {
      this.isShowTaxIcon = true
    }
    //演示账号不出现扫一扫
    if(this.$store.state.userInfo && this.$store.state.userInfo.name == "13823241000"){
      this.isTestAccount = true
    }
    this.$root.$emit('log-record',"60010096");
    if(this.$store.state.accountHomeInfo && Object.keys(this.$store.state.accountHomeInfo).length > 0){
      this.setInfo(this.$store.state.accountHomeInfo);
    }
    this.getCompanyInfo();
    this.getCompanyList();
    this.getRedPointStatus();
    this.getServiceInfo();
    this.getPeriodicServiceBeta();
    //滚动条置顶
    document.documentElement.scrollTop = document.body.scrollTop = 0;
    //改变body底色
    document.getElementsByTagName("body")[0].style.backgroundColor = "#F9FBFC";

    // 年度账单弹框
    let from = this.$route.params.from
    // 年度账单倒计时
    let self = this
    if (self.timerJump == 5 && from == 'login') {
      var timerJumpFun = setInterval(function() {
        if (self.timerJump == 0) {
          clearInterval(timerJumpFun)
          self.timerJump = ''
          self.closeFun()
        } else {
          self.timerJump--
        }
      }, 1000)
    }
    if (!this.isActiveBg) {
      let htmlObj = document.getElementsByTagName('html')[0]
      htmlObj.style.overflow= "hidden";
    } else {
      let htmlObj = document.getElementsByTagName('html')[0]
      htmlObj.style.overflow= "auto";
    }
  },
  methods: {
    getRnv() {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
        wx.miniProgram.getEnv(res => {
          if (res.miniprogram) {
            this.env = "miniprogram";
          } else {
            this.env = "public";
          }
        });
      } else {
        this.env = "public";
      }
    },
    //获取crm beta权限
    getCrmBetaStatus(){
      this.$http
        .get("/fc/crm/queryCrmBata?accCompanyId=" + this.company_value)
        .then(res => {
          if(res.data === true){
            this.crmBeta = true
          }else{
            this.crmBeta = false
          }
        })
        .catch(error => {
          console.log(error, "error");
        });
    },
    linkSkip(name, params, redType, rid, eventName) {
      if (name == 'businessManage') {
        if(!this.estimatePowerCrm("商机管理") || this.isCrmEndDate){
          Toast("没有权限！");
          return;
        }
        this.$http
        .get("/fc/small/program/crm/menurl?menuId=2000&accCompanyId=" + this.company_value)
        .then(res => {
          if (res.data.code == 200) {
            params.url = res.data.data;
            this.$router.push({
              name: name,
              params: params
            });
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          console.log(error, "error");
        });
      } else {
        if (redType) {
          this.handleClickRedPoint(redType);
        }
        if (rid) {
          this.$root.$emit("log-record", rid);
        }
        if(eventName){
          window._hmt.push(['_trackEvent', eventName, "点击", this.roleValue]);
        }
        if(name == 'wxRenew_list'){
          if(!this.estimatePower("财务管理","收款跟进")){
            Toast("没有权限：收款跟进-显示菜单");
            return;
          }
        }
        if(name == 'fieldAssignment_list'){
          if(!this.estimatePower("外勤管理","外勤任务")){
            Toast("没有权限：外勤任务-显示菜单");
            return;
          }
        }
        if(name == 'collectionHome'){
          if(!this.estimatePower("客户管理","合同","新增")){
            Toast("没有权限：合同-新增");
            return;
          }
        }
        if(name == 'customerBillList'){
          if(!this.estimatePower("代账服务","服务管理","收票")){
            Toast("没有权限：代账服务-服务管理-收票");
            return;
          }
        }
        if(name == 'businessServiceList'){
          if(!this.estimatePower("工商服务","服务管理")){
            Toast("没有权限：工商服务-服务管理-显示菜单");
            return;
          }
        }
        //注释新增的查看跟进记录权限，因为缓存问题小程序取不到新增的权限
        // if(name == 'customerFollowList'){
        //   if(!this.estimatePower("客户管理","客户","查看跟进记录")){
        //     Toast("没有权限：客户管理-客户-查看跟进记录");
        //     return;
        //   }
        // }
        this.$router.push({
          name: name,
          params: params
        });
      }
    },
    //获取职员权限
    getPowerData(staffId){
      // let staffId = window.sessionStorage.getItem("staffId");
      if(!staffId){
        return
      }
      let powerData = this.$store.state.powerData
      if (!powerData || powerData.length==0) {
        Toast.loading({
          mask: true,
          message: '访问中，请等待...'
        });
      }
      this.$http
        .get("/fc/small/program/staff/power?staffId=" + staffId)
        .then(res => {
          console.log(res, "/staff/power?");
          if (res.data.code == 200) {
            this.powerData = res.data.data;
            this.$store.dispatch("setPowerData", res.data.data);
          } else {
            Toast(res.data.msg);
          }
          Toast.clear();
        })
        .catch(error => {
          console.log(error, "error");
          Toast.clear();
        });
    },
    //判断职员权限
    estimatePower (menuName,tabName,operateName) {
      for(let i=0,lenI=this.powerData.length;i<lenI;i++){
        //  判断菜单名
        if(menuName==this.powerData[i].name){
          for(let j=0,lenJ=this.powerData[i].children.length;j<lenJ;j++){
            //  判断页签名
            if(tabName==this.powerData[i].children[j].name){
              if(!operateName){
                return this.powerData[i].children[j].status;
              }else{
                for(let k=0,lenK=this.powerData[i].children[j].children.length;k<lenK;k++){
                  //  判断
                  if(operateName==this.powerData[i].children[j].children[k].name){
                    return this.powerData[i].children[j].children[k].checked;
                  }
                }
              }
            }
          }
        }
      }
    },
    //判断职员CRM权限
    estimatePowerCrm (menuName) {
      for(let i=0,lenI=this.powerData.length;i<lenI;i++){
        //  判断菜单名
        if(menuName==this.powerData[i].name){
          return this.powerData[i].status;
        }
      }
    },
    getCompanyList() {
      let url = "/fc/small/program/acccomapnys";
      if (window.sessionStorage.getItem("eid")) {
        url = url + "?eid=" + window.sessionStorage.getItem("eid");
      }
      this.$http
        .get(url)
        .then(res => {
          console.log(res, "/fc/small/program/acccomapnys");
          if (res.data.code == 200) {
            let accCompanyId = this.$cookieStore.getCookie('accCompanyId');
            let currentCompanyList =
              res.data.data.companys.items.length > 0 &&
              res.data.data.companys.items.filter(c => {
                return c.accCompanyId == accCompanyId;
              });
            this.company_option =
              res.data.data.companys.items.length > 0 &&
              res.data.data.companys.items.map(c => {
                return { text: c.name, value: c.accCompanyId };
              });
            if (currentCompanyList.length > 0) {
              this.$store.dispatch("setAcctCompanyInfo", currentCompanyList[0]);
              this.company_value = currentCompanyList[0].accCompanyId;
              this.getCrmBetaStatus()
              // 商机管理服务到期
              this.getServiceDate()
              // if(currentCompanyList[0].eid){
              //   this.currentEid = currentCompanyList[0].eid;
              // }
            }
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          console.log(error, "error");
        });
    },
    async openedDropdownMenu() {
      this.beforeAccCompanyId = this.company_value
    },
    async handleCompanyChange(val) {
      window._hmt.push(['_trackEvent', "切换圈子", "下拉选择", this.roleValue]);
      this.$root.$emit("log-record", "60010098");
      this.customerData = [];
      //退出苍穹
      let crmToken = await this.getCrmToken()
      if (crmToken) {
        await this.crmLogout(crmToken)
      }
      const params = { accCompanyId: val };
      this.$http
        .get("/fc/small/program/switchacccompany", { params: params })
        .then(res => {
          console.log(res, "/fc/small/program/switchacccompany");
          if (res.data.code == 200) {
            this.$store.dispatch("setAcctCompanyInfo", res.data.data);
            this.$cookieStore.setCookie('accCompanyId',val);
            this.getCompanyList();
            this.getCompanyInfo();
            this.getRedPointStatus();
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          console.log(error, "error");
        });
    },
    getCompanyInfo() {
      this.$http
        .get("/fc/small/program/staffinfocus")
        .then(res => {
          console.log(res, "/fc/small/program/staffinfocus");
          this.$store.dispatch("setAccountHomeInfo", res);
          this.setInfo(res);
          if (res.data.code == 200) {
            this.getPowerData(res.data.data.staffId)
            this.$store.dispatch("updateStaffInfoStaffIdFun", res.data.data.staffId);
          }else{
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          console.log(error, "error");
        });
    },
    setInfo(res) {
      if (res.data.code == 200) {
        const target = res.data.data;
        this.cuTotal = target.customerCount;
        this.asRightText = target.acct;
        this.bsRightText = target.business;
        this.expexpiredCount = target.expexpiredCount;
        this.feeNot = target.feeNot;
      } else {
        Toast(res.data.msg);
      }
    },
    getRedPointStatus() {
      this.$http
        .get("/fc/small/program/check/staffredpoint")
        .then(res => {
          console.log(res, "/fc/small/program/check/staffredpoint");
          if (res.data.code == 200) {
            if (res.data.data.mission == 1) {
              this.missionBandge = true;
            } else {
              this.missionBandge = false;
            }
            if (res.data.data.businss == 1) {
              this.bussBandge = true
            } else {
              this.bussBandge = false
            }
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          console.log(error, "error");
        });
    },
    handleClickRedPoint(type) {
      const params = { type: type };
      this.$http
        .get("/fc/small/program/add/staffredpoint", { params: params })
        .then(res => {
          console.log(res, "/fc/small/program/add/staffredpoint");
          if (res.data.code == 200) {
            console.log("点击红点通知后台成功！");
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          console.log(error, "error");
        });
    },
    getCurrentEid () {
      return this.$http.get("/fc/small/program/qr/auth");
    },
    //微信扫一扫
    async scanQrcode() {
      window._hmt.push(['_trackEvent', "点击扫一扫", "点击", this.roleValue]);
      try{
      let res = await this.getCurrentEid();
      let currentEid = '';
      if(res.data.code == 200 && res.data.data){
        currentEid = res.data.data
      }
      let params = {
        url: encodeURIComponent(window.location.href.split("#")[0]),
        eid: currentEid
      };
      var $this = this;
      this.$http
        .get("/ommall/wxthird/jssdk?url=" + params.url + "&eid=" + params.eid)
        .then(res => {
          if (res.data.code == 200) {
            let data = res.data.data;
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: data.auth_appid, // 必填，公众号的唯一标识
              timestamp: data.timestamp, // 必填，生成签名的时间戳
              nonceStr: data.nonceStr, // 必填，生成签名的随机串
              signature: data.signature, // 必填，签名，见附录1
              jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
            var scanData = {
              needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
              scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
              success: function (res) {
                var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                $this.sendQRToken(result);
              }
            };
            wx.ready(function() {
              wx.scanQRCode(scanData);
            });
          } else {
            Toast("请求微信扫码失败！");
          }
        })
        .catch(err => {
          Toast(err);
        });
      }catch(error){
        console.log(error)
      }
    },
    // 扫完之后把qrToken传给后端
    sendQRToken(qrToken) {
      var stateInfo = this.$store.state;
      const params = {
        qrToken: qrToken,
        userId: stateInfo.userInfo && stateInfo.userInfo.userId,
        eid: stateInfo.acctCompanyInfo && stateInfo.acctCompanyInfo.eid,
        accCompanyId: stateInfo.acctCompanyInfo && stateInfo.acctCompanyInfo.accCompanyId,
        env: stateInfo.acctCompanyInfo && stateInfo.acctCompanyInfo.env
        };
      this.$http
        .get("/fc/small/program//qr/info", { params: params })
        .then(res => {
          if (res.data.code == 200) {
            Toast("扫码成功，正在登录中，请稍候！");
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          console.log(error, "error");
        });
    },
    // 年度盘点取数
    // 关闭弹框
    closeFun(type) {
      this.isActive = 1
      this.isTimerJump = false
      if (type) {
        window.localStorage.setItem('yearInfoOpen2021', true)
      }
      var htmlObj = document.getElementsByTagName('html')[0]
      htmlObj.style.overflow= "auto";
      setTimeout(() => {
        this.isActiveBg = true
      }, 1000)
    },
    openYearInfo() {
      this.isActiveBg = true
      window.localStorage.setItem('yearInfoOpen2021', true)
      var htmlObj = document.getElementsByTagName('html')[0]
      htmlObj.style.overflow= "auto";
      this.$router.push({
        name: 'yearIndex2021'
      })
    },
    //获取用户角色以方便记录埋点
    getServiceInfo () {
      this.$http.get('/fc/small/program/staffbaseinfo').then(res => {
        console.log(res,'/fc/small/program/staffbaseinfo')
        if (res.data.code == 200) {
          let result = res.data.data
          this.roleValue = result.roleValue
        }
      })
    },
    // 获取CRM的token
    getCrmToken () {
      return this.$http.get('/fc/small/program/crm/token?accCompanyId=' + this.beforeAccCompanyId).then((response) => {
        if(response.data.code==200){
          return response.data.data
        } else {
          return false
        }
      }, () => {
        return false
      });
    },
    //退出苍穹
    crmLogout (crmToken) {
      // let crmHost = 'https://mswy.kdzwy.com/ierp/api/logout.do?access_token=' + crmToken // 模拟
      let crmHost = window.location.protocol + '//' + window.location.host + '/ierp/api/logout.do?access_token=' + crmToken // 正式
      this.$http.get(crmHost).then((response) => {
        if(response.data.code==200){
          console.log('退出CRM成功')
        } else {
          console.log(response.data.msg)
        }
      }, (response) => {
        console.log(response.data.msg)
      });
    },
    getServiceDate () {
      this.$http.get('/fc/small/program/crm/serviceDate?accCompanyId=' + this.company_value).then((response) => {
        if(response.data.code==200){
          let crmEndDate = response.data.data.crmEndDate
          let currentDay = moment().locale('zh-cn').format('YYYY-MM-DD')
          let crmEndDateTemp = Date.parse(crmEndDate);
          let currentDate = Date.parse(currentDay);
          let mss = Number(crmEndDateTemp) - Number(currentDate)
          let days = mss / (1000 * 60 * 60 * 24);
          if (days < -90) {
            this.isCrmEndDate = true
          }
        } else if (response.data.code==632) {
          console.log(response.data.msg)
          this.isCrmEndDate = true
        } else {
          console.log(response.data.msg)
          this.isCrmEndDate = true
        }
      }, (response) => {
        console.log(response.data.msg)
      })
    },
    getPeriodicServiceBeta(){
      this.$http.get("/fc/small/program/bussPeriodBeta").then(
        response => {
          if (response.data.code == 200) {
            window.sessionStorage.setItem('_isPeriodicServiceBeta',response.data.data)
          }
        },
        (response) => {
        console.log(response.data.msg)
      }
      );
    },
  },
  beforeDestroy() {
    //还原body底色
    document.getElementsByTagName("body")[0].style.backgroundColor = "#f0f2f2";
  }
};
</script>
<style lang="stylus" scoped>
.accountHome {

  padding-bottom: 0.62rem;
  overflow: auto;
  .security_blue {
    width: 0.25rem;
    height: 0.25rem;
    margin: 0 auto 0.02rem auto;
  }
  .security_blue img {
    width: 0.25rem;
    height: 0.25rem;
  }
  .iconfont.block.mb5 {
    font-size: 0.22rem;
  }

  .head {
    height: 2.3rem;
    background: url('../../assets/images/customer/homeBg.png') center no-repeat;
    background-size: cover;

    .van-dropdown-menu {
      background: rgba(2, 175, 254, 0.7);
      color: #ffffff;
      height: 0.44rem;
      line-height: 0.44rem;
      position: static;
    }

    .swipeContent {
      height: 1.52rem;
      text-align: center;
      color: #ffffff;

      .newCl {
        margin-top: 0.24rem;
        height: 0.65rem;

        .number {
          font-size: 0.64rem;
        }

        .symbol {
          font-size: 0.22rem;
        }
      }

      .van-icon-arrow {
        position: relative;
        top: 0.02rem;
        margin-left: 0.04rem;
      }
    }
  }

  .mainContainer {
    margin: 0 0.12rem;
    // border: 1px solid #e6ebf0;
    -webkit-box-shadow: 0px 2px 8px 0px rgba(44, 62, 80, 0.1);
    box-shadow: 0px 2px 8px 0px rgba(44, 62, 80, 0.1);
    border-radius: 6px;
    background-color: #fff;
    margin-top: -0.54rem;
    padding: 0.12rem 0;

    .mainContainerCol {
      position: relative;
      padding: 0.14rem 0;
      text-align: center;

      .title {
        font-weight: 400;
        color: #2c3e50;
        font-size: 0.15rem;
        margin-top: 0.06rem;
      }

      .bline {
        height: 0.4rem;
        border-right: 1px solid #e6ebf0;
        display: inline-block;
        position: absolute;
        right: 0.01rem;
        top: 0.24rem;
      }

      img {
        width: 0.29rem;
      }

      // .fImg {
      //   width: 0.26rem;
      // }

      // .bImg {
      //   width: 0.26rem;
      // }

      // .mImg {
      //   width: 0.26rem;
      // }
    }
  }

  .bandge {
    display: inline-block;
    width: 4px;
    height: 4px;
    background-color: #FE4E21;
    border-radius: 100%;
    position: absolute;
    right: 0.16rem;
    top: 0.24rem;
  }
   
  .confirmed {
    margin: 0 0.12rem;
    // border: 1px solid #E6EBF0;
    box-shadow: 0px 2px 8px 0px rgba(44, 62, 80, 0.1);
    border-radius: 6px;
    margin-top: 0.1rem;
    background-color: #ffffff;
    padding: 0.12rem;

    .empty {
      text-align: center;
      height: 1.04rem;
      line-height: 1.04rem;

      img {
        width: 0.32rem;
        height: 0.32rem;
      }

      .desc {
        color: #B4BEC7;
        margin-left: 0.08rem;
        display: inline-block;
        vertical-align: text-bottom;
        height: 0.32rem;
        line-height: 0.28rem;
      }
    }

    .title {
      font-size: 0.15rem;
      font-weight bold
      color #1B2734

      .more {
        float: right;
        font-size: 0.14rem;
        color: #8896A4;
      }
    }

    .confirmedRow {
      padding: 0.08rem 0;

      img {
        height: 0.22rem;
        width: 0.22rem;
        margin-top: 0.075rem;
      }

      .stitle {
        font-size: 0.15rem;
        color: #2C3E50;
        line-height: 0.37rem;
        padding-left: 0.06rem;
      }

      .rightText {
        text-align: right;
        line-height: 0.37rem;
        color: #8896A4;
        font-size: 0.15rem;
        position: relative;

        .van-icon-arrow:before {
          position: relative;
          top: 0.02rem;
        }
      }
    }

    .confirmedInvest.confirmedRow {
      padding-bottom: 0;
      padding-top: 0;
    }

    .confirmedInvest.confirmedRow.margintop {
      margin-top: 0.08rem;
    }

    .telNumber {
      padding: 0.14rem;
      text-align: center;
      border-bottom: 1px solid #e9e9e9;
      font-size: 16px;
    }

    .telAction {
      padding: 0.14rem;
      text-align: center;
      border-bottom: 1px solid #e9e9e9;
      font-size: 16px;

      a {
        color: #8896A4;
      }
    }
  }
  .scan-btn-wrap{
    width: 0.44rem;
    height:0.44rem;
    position: absolute;
    right: 0;
    top: 0;
    color: #ffffff;
    z-index: 9;
  }
  .scan-btn{
    width: 0.2rem;
    height:0.2rem;
    background: url('../../assets/images/scanIcon.png') center no-repeat;
    background-size: cover;
    position: absolute;
    right: 0.12rem;
    top: 0.12rem;
  }
  .myCustomer{
    font-size 0.16rem;
  }

  // 年度数据盘点
  .cover-box {
    position: absolute;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 999;
    .img-bg {
      position: absolute;
      background: url('../../assets/images/yearData/2021/year-bill-dialog.jpg') center no-repeat;
      background-size: cover;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .cover-btn {
        width: 1.7rem;
        // height: 0.45rem;
        bottom: 10%;
        position: absolute;
      }
      .close {
        width: 0.16rem;
        height: 0.16rem;
        right: 0.04rem;
        top: 0.04rem;
      }
    }
  }
  .look-again-btn {
    position: absolute;
    top: 0.16rem;
    right: 0.16rem;
    font-size: 0.1rem;
    padding: 0.04rem 0.1rem;
    border-radius: 0.11rem;
    background: rgba(0,0,0,0.3);
    color: #fff;
  }
  .dialog-cover-box {
    transition:all 1s;
    -moz-transition:all 1s; /* Firefox 4 */
    -webkit-transition:all 1s; /* Safari and Chrome */
    -o-transition:all 1s; /* Opera */
    transition-timing-function: ease;
    -moz-transition-timing-function: ease; /* Firefox 4 */
    -webkit-transition-timing-function: ease; /* Safari 和 Chrome */
    -o-transition-timing-function: ease; /* Opera */
  }
  .logo-box {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 0.8rem;
    img {
      width: 70%;
    }
  }
  .is-cover-box-hide2 {width: 0 !important;height: 0 !important;top: calc(100% - 0.25rem) !important;left:75% !important}
  .is-cover-box-hide3 {width: 0 !important;height: 0 !important;top: calc(100% - 0.25rem) !important;left:83.3% !important}
  .is-hide {display: none;}
}
</style>
<style>
.accountHome .van-dropdown-menu__title{
  color:#ffffff;
  font-size: 0.16rem;
}
.accountHome .head .van-dropdown-menu__title::after {
  top: 0.1rem;
}
.accountHome .van-dropdown-menu__item{
  justify-content: start;
  padding-left: 0.04rem;
}
</style>



